export default __webpack_public_path__ + "static/media/Menu.a07376a5.svg";